/**
 * Mutu Ancak API Configuration
 * Centralized API endpoint constants
 */

export const MUTU_ANCAK_API_CONFIG = {
  SUMMARY: '/api/inspection/mutu-ancak/summary',
  // Add more endpoints here as needed
} as const;

export const DEFAULT_CATEGORY_ID = 10; // Quality inspection category
